import React, { useContext } from 'react';
import { VerticalTabsContext } from '../VerticalTabs/VerticalTabsContext';
import { InjectedFocusableProps, withFocusable } from '../common/Focusable';
import { VerticalTabsItemProps } from './VerticalTabsItem.types';
import { SelectableItem } from './components/SelectableItem';
import { TitleItem } from './components/TitleItem';
import { ActionItem } from './components/ActionItem';

const VerticalTabsItem = <TabId extends string | number = number>({
  id,
  type = 'tab',
  tabIndex,
  ...rest
}: InjectedFocusableProps<VerticalTabsItemProps<TabId>, HTMLDivElement>) => {
  const {
    activeTabId,
    onChange,
    size,
    ellipsis,
    skin: baseSkin,
  } = useContext(VerticalTabsContext);

  const contextProps = {
    activeTabId,
    onChange,
    size,
    baseSkin,
    ellipsis,
  };

  const selected =
    id !== undefined && activeTabId !== undefined && id === activeTabId;

  if (type === 'action') {
    return <ActionItem {...contextProps} {...rest} />;
  }

  if (type === 'title') {
    return <TitleItem {...contextProps} {...rest} />;
  }

  return (
    <SelectableItem
      id={id}
      tabIndex={tabIndex ?? (rest.disabled ? -1 : 0)}
      selected={selected}
      {...contextProps}
      {...rest}
    />
  );
};

VerticalTabsItem.displayName = 'VerticalTabsItem';
const WrappedVerticalTabsItem =
  withFocusable<VerticalTabsItemProps<number | string>>(VerticalTabsItem);

export { WrappedVerticalTabsItem as VerticalTabsItem };
